/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components */
import {
  attributeBindings,
  classNames,
  tagName,
} from '@ember-decorators/component';
import Component from '@ember/component';
import { scheduleOnce } from '@ember/runloop';
import { isEmpty } from '@ember/utils';
import timeline from 'linced-app/utils/d3-timeline';
import { select } from 'd3-selection';

@tagName('svg')
@classNames('chart', 'chart-timeline')
@attributeBindings('width')
export default class ChartTimeline extends Component {
  start = 0;
  end = 0;
  width = 960;
  margin = Object.freeze({ top: 0, right: 20, bottom: 30, left: 150 });
  data = [];

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    // Schedule a call to our `draw` method on Ember's "render" queue, which will
    // happen after the component has been placed in the DOM, and subsequently
    // each time data is changed.
    scheduleOnce('render', this, this.draw);
  }

  draw() {
    if (isEmpty(this.data)) {
      // No point trying to chart an empty data set.
      return;
    }
    let chart = timeline()
      .stack()
      .width(this.width)
      .margin(this.margin)
      .itemMargin(0)
      .beginning(this.start * 1000)
      .ending(this.end * 1000)
      .showTimeAxisTick()
      .background(function (datum, i) {
        let odd = i % 2 === 0;
        return odd ? '#ddd' : '#fff';
      });
    // Remove the "height" attribute if present, so that it will be recalculated on redraws.
    select(this.element).attr('height', null).datum(this.data).call(chart);
  }
}
